export default __webpack_public_path__ + "static/media/Image29.18088043.png";